<template>
  <div v-if="style == 'default'">
    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    style: {
      type: String,
      default: 'default'
    }
  }
}
</script>
